module.exports = __webpack_public_path__ + "img/wander1.36148520.jpg";